<template>
  <div class="defaultPage">
    <div class="big_banner w">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(value, index) in title" :key="index">
            <div class="swiper-slide">
              <div class="big_banner_left">
                <a :href="value.url">
                  <img :src="dealImg(value.img)" :title="value.title" target="_blank" />
                </a>
                <p>
                  {{ value.desc }}&nbsp;
                  <i class="iconfont i_more">&#xe620;</i>
                </p>
              </div>
              <div class="big_banner_right">
                <a :href="item.url" target="_blank" v-for="(item, index) in value.matches" :key="index">
                  <div :class="index == 0 ? 'banner_top' : 'banner_bottom'">
                    <span>
                      <img :src="dealImg(item.home_logo)"
                        onerror="javascript:this.src='//static.fly2a.com/static/image/f-live/no-img2.png'" alt />
                      <span>{{ item.home_name_zh }}</span>
                    </span>
                    <span class="saishi">
                      <span>{{ item.league_name_zh }}</span>
                      <span>▁</span>
                    </span>
                    <span>
                      <img :src="dealImg(item.away_logo)"
                        onerror="javascript:this.src='//static.fly2a.com/static/image/f-live/no-img2.png'" alt />
                      <span>{{ item.away_name_zh }}</span>
                    </span>
                  </div>
                </a>
                <a href="#" target="_blank" v-if="value.matches.length <= 0">
                  <div class="banner_top"></div>
                </a>
                <a href="#" target="_blank" v-if="value.matches.length <= 1">
                  <div class="banner_bottom"></div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
    <div class="small_banner w">
      <dl>
        <dt>
          <div class="advertisement">赛事分析即时呈现 永久域名gqj1.tv</div>
          <div class="hot-title">
            <img src="//static.fly2a.com/static/image/index-hot/hot.png" />
            <span>热门赛事</span>
          </div>
          <div class="hot-nav" @click="hot_click(2)">
            <img :src="hotIndex == 2
            ? '//static.fly2a.com/static/image/index-hot/hot-lanqiu.png'
            : '//static.fly2a.com/static/image/index-hot/hot-lanqiu2.png'
            " />
            <span :class="hotIndex == 2 ? 'isAction' : ''">篮球比分</span>
          </div>
          <div class="hot-nav" @click="hot_click(1)">
            <img src="//static.fly2a.com/static/image/index-hot/hot-zuqiu.png" />
            <span :class="hotIndex == 1 ? 'isAction' : ''">足球</span>
          </div>
        </dt>
        <dd>
          <a :href="toLive(item.tournament_id)" target="_blank" class="hot-list" :data-id="item.tournament_id"
            v-for="(item, index) in hotmatches" :key="index" :style="index % 2 == 0 ? '' : 'background:#F8F6F6;'">
            <div class="w1" :style="'border-left:5px solid' + item.color + ';color:' + item.color
            ">{{ item.league_name_zh }}</div>
            <div class="w2">{{ item.match_time }}</div>
            <div class="w3" v-if="hotIndex == 1">
              <span v-if="item.state == 0">未开赛</span>
              <span v-else-if="item.state >= 1 && item.state <= 5" class="timeName" style="color: #ff9000">
                {{ item.on_time }}
                <span class="move-dian">'</span>
              </span>
              <span v-else-if="item.state == -1">完场</span>
              <span v-else-if="item.state == -14">推迟</span>
              <span v-else-if="item.state == -13">中断</span>
              <span v-else-if="item.state == -12">腰斩</span>
              <span v-else-if="item.state == -10">取消</span>
              <span v-else class="timeName">待定</span>
            </div>
            <div class="w3" v-else>
              <span v-if="item.state == 0">未开赛</span>
              <span :style="item.on_time && item.state >= 1 ? 'color:#ff9000;' : ''" v-else>
                {{
            item.league_name_zh == "NCAA"
              ? stateNameNcaa[item.state]
              : stateName[item.state]
          }}
              </span>
              <span v-if="item.on_time && item.state >= 1 && item.state != 50" style="color: #ff9000">{{
            ontimeFn(item.on_time) }}</span>
            </div>
            <div class="w4">
              <span>{{ item.home_name_zh }}{{ item.home_team_zh }}</span>
              <img :src="dealImg(item.home_logo)"
                onerror="javascript:this.src='//static.fly2a.com/static/image/f-live/no-img2.png'" alt />
            </div>
            <div class="w5">
              <span v-if="item.state != 0">{{ item.home_score }} - {{ item.away_score }}</span>
              <span v-else>-</span>
            </div>
            <div class="w6">
              <img :src="dealImg(item.away_logo)"
                onerror="javascript:this.src='//static.fly2a.com/static/image/f-live/no-img2.png'" alt />
              <span>{{ item.away_name_zh }}{{ item.away_team_zh }}</span>
            </div>
            <div class="w7">
              <!-- <span v-if="item.seleltname" class="bigSmall">
                <img src="//static.fly2a.com/static/image/ball_icon.png" />
                <span>{{ item.seleltname }}</span>
              </span>-->
            </div>
            <div class="w8">
              <img :src="dealImg(item.analyst_face)" :title="item.analyst_name" height="36px"
                @click="toAnalyst(item.member_id, item.recommend_id)" />
            </div>
          </a>
        </dd>
      </dl>
    </div>
    <div class="news clearfix w">
      <div class="news_left">
        <div class="news_title">
          <ul>
            <li v-for="(item, index) in newsLi" :key="index" :class="{ news_active: index === newsIndex }"
              @mouseenter="news_click(index)" :type1="index">{{ item }}</li>
            <li @click="news_click(6)">幸运球场</li>
          </ul>
        </div>
        <div class="news_content">
          <ul v-for="(item, index) in newslist" :key="index" v-show="index === newsIndex">
            <a :href="'/news/detail/' + data.id" target="_blank" v-for="(data, idx) in item" :key="idx">
              <li class="clearfix">
                <div class="left_news_content">
                  <img :src="data.img" @error="onNewsCoverError" />
                </div>
                <div class="right_news_content">
                  <p>{{ data.title }}</p>
                  <p>{{ data.content | formateHtml }}</p>
                  <p>{{ data.created_at }}</p>
                </div>
              </li>
            </a>
          </ul>
        </div>
      </div>
      <div class="news_right">
        <div class="jifen_title">
          <div>积分榜</div>
        </div>
        <div class="jifen_nav">
          <ul>
            <li :class="jifenIndex == 0 ? 'jifen_active' : ''" @mouseenter="jifen_click(0)">中超</li>
            <li :class="jifenIndex == 1 ? 'jifen_active' : ''" @mouseenter="jifen_click(1)">英超</li>
            <li :class="jifenIndex == 2 ? 'jifen_active' : ''" @mouseenter="jifen_click(2)">西甲</li>
            <li :class="jifenIndex == 3 ? 'jifen_active' : ''" @mouseenter="jifen_click(3)">德甲</li>
            <li :class="jifenIndex == 4 ? 'jifen_active' : ''" @mouseenter="jifen_click(4)">意甲</li>
            <li :class="jifenIndex == 5 ? 'jifen_active' : ''"
              :style="jifenIndex == 6 ? 'display:none;' : 'display:block;'" @mouseenter="jifen_click(5)">NBA</li>
            <li :class="jifenIndex == 6 ? 'jifen_active' : ''"
              :style="jifenIndex != 6 ? 'display:none;' : 'display:block;'" @mouseenter="jifen_click(6)">NBA</li>
            <li :class="jifenIndex == 7 ? 'jifen_active' : ''" @mouseenter="jifen_click(7)">CBA</li>
            <!--<li v-for="(item,index) in jifenLi" :class="{'jifen_active':index === jifenIndex}" @mouseenter="jifen_click(index)" :type1="index">{{item}}</li>-->
          </ul>
        </div>
        <div class="nab_nav" v-show="jifenIndex === 5 || jifenIndex === 6">
          <ul>
            <li :class="jifenIndex === 5 ? 'nab-ative' : ''" @mouseenter="jifen_click(5)">东部</li>
            <li :class="jifenIndex === 6 ? 'nab-ative' : ''" @mouseenter="jifen_click(6)">西部</li>
          </ul>
        </div>
        <!-- @mouseenter="jifen_enter()" @mouseleave="jifen_leave()"-->
        <div class="jifen_all">
          <div class="jifen_content">
            <ul class="jifen_content_title" v-show="jifenIndex >= 0 && jifenIndex <= 4">
              <li>
                <div>排名</div>
                <div>球队</div>
                <div>胜/平/负</div>
                <div>积分</div>
              </li>
            </ul>
            <ul class="jifen_content_title title1" v-show="jifenIndex == 5">
              <li>
                <div>排名</div>
                <div>球队</div>
                <div>胜/负</div>
                <div>胜场差</div>
              </li>
            </ul>
            <ul class="jifen_content_title title2" v-show="jifenIndex == 7">
              <li>
                <div>排名</div>
                <div>球队</div>
                <div>胜/负</div>
                <div>场均分</div>
              </li>
            </ul>
            <div id="rank_container">
              <div :class="'jifen_view jifen' + index" v-for="(item, index) in rank" :key="index">
                <div class="jifen_view" :ref="index">
                  <ul class="view1" v-show="index == jifenIndex">
                    <li v-for="(data, idx) in item" :key="idx">
                      <div>{{ data.ranking }}</div>
                      <div>
                        <img :src="data.logo" />
                        <span v-html="data.team"></span>
                      </div>
                      <div>{{ data.mark }}</div>
                      <div>{{ data.points }}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="today_tuijian w">
      <div class="tuijian_title">今日精推</div>
      <div class="tuijian_nav">
        <div @click="tuijianIndex = 0" :class="tuijianIndex == 0 ? 'tuijian_active' : ''">足球</div>
        <div @click="tuijianIndex = 1" :class="tuijianIndex == 1 ? 'tuijian_active' : ''">篮球</div>
      </div>
    </div>
    <div class="index_content clearfix w">
      <div class="index_content1">
        <div class="content1_top tuijian1" v-show="tuijianIndex == 0">
          <div class="vwrapper" v-for="(item, index) in f_comment" :key="index">
            <img v-if="item.is_hit == 1" class="hit" src="//static.fly2a.com/static/image/hit.png" />
            <img v-else-if="item.is_hit == 2" class="hit" src="//static.fly2a.com/static/image/nohit.png" />

            <div class="recommend" v-if="!!item.description">{{ item.description.substr(0, 2) }}</div>

            <table>
              <tbody>
                <tr>
                  <td rowspan="2">
                    <a :href="'/tuijian/football-analyst?member_id=' +
            item.analyst_id +
            '&recommend_id=' +
            item.recommend_id +
            '&newsIndex=' +
            newsIndex
            " target="_blank">
                      <img :src="dealImg(item.analyst_face)" />
                    </a>
                    <p class="name">{{ item.analyst_name }}</p>
                    <p>
                      <span>{{ item.level }}</span>
                    </p>
                  </td>
                  <td>
                    <p :comment="item.seleltname" class="champion">
                      <span v-if="item.seleltname == item.home_name_zh" class="home">
                        <i class="yellowcard" v-if="item.home_yellow > 0">
                          {{
            item.home_yellow
          }}
                        </i>
                        <i class="redcard" v-if="item.home_red > 0">
                          {{
            item.home_red
          }}
                        </i>
                        {{ item.home_name_zh }}
                        <img src="//static.fly2a.com/static/image/left-champion.png" v-if="item.price == 0" />
                      </span>
                      <span v-else class="home">
                        <i class="yellowcard" v-if="item.home_yellow > 0">
                          {{
            item.home_yellow
          }}
                        </i>
                        <i class="redcard" v-if="item.home_red > 0">
                          {{
            item.home_red
          }}
                        </i>
                        {{ item.home_name_zh }}
                      </span>

                      <span>
                        <template v-if="item.state == -1">
                          {{ item.home_score }} -
                          {{ item.away_score }}
                        </template>
                        <template v-else>VS</template>
                        <span class="time">
                          {{ item.league_name_zh }}&nbsp;{{
            item.matches_time
          }}
                        </span>
                      </span>

                      <span v-if="item.seleltname == item.away_name_zh" class="away">
                        {{ item.away_name_zh }}
                        <img src="//static.fly2a.com/static/image/right-champion.png" v-if="item.price == 0" />
                        <i class="redcard" v-if="item.away_red > 0">
                          {{
            item.away_red
          }}
                        </i>
                        <i class="yellowcard" v-if="item.away_yellow > 0">
                          {{
            item.away_yellow
          }}
                        </i>
                      </span>
                      <span v-else class="away">
                        {{ item.away_name_zh }}
                        <i class="redcard" v-if="item.away_red > 0">
                          {{
            item.away_red
          }}
                        </i>
                        <i class="yellowcard" v-if="item.away_yellow > 0">
                          {{
            item.away_yellow
          }}
                        </i>
                      </span>

                      <!-- <span
                        v-if="item.seleltname=='大球'||item.seleltname=='小球'&&item.price==0"
                        class="bigSmall"
                      >
                        <img src="//static.fly2a.com/static/image/ball_icon.png" />
                        <span>{{item.seleltname}}</span>
                      </span>-->
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="comments">
                      <span v-if="item.price == 0">{{ item.content }}</span>
                      <a class="lock" href="/app" target="_blank" v-else>
                        <img src="//static.fly2a.com/static/image/lock.png" width="30px" />
                        <br />
                        <span>看推文分析请点击下载</span>
                        <span style="color: red">APP</span>
                      </a>
                    </p>
                    <p>
                      <a :href="'/tuijian/football-analyst?member_id=' +
            item.analyst_id +
            '&recommend_id=' +
            item.recommend_id +
            '&newsIndex=' +
            newsIndex
            " target="_blank">
                        查看更多
                        <img src="//static.fly2a.com/static/image/more2.png" />
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="content1_top tuijian2" v-show="tuijianIndex == 1">
          <div class="vwrapper" v-for="(item, index) in b_comment" :key="index">
            <img v-if="item.is_hit == 1" class="hit" src="//static.fly2a.com/static/image/hit.png" />
            <img v-else-if="item.is_hit == 2" class="hit" src="//static.fly2a.com/static/image/nohit.png" />

            <table>
              <tbody>
                <tr>
                  <td rowspan="2">
                    <a :href="'/tuijian/football-analyst?member_id=' +
            item.analyst_id +
            '&recommend_id=' +
            item.recommend_id +
            '&newsIndex=' +
            newsIndex
            " target="_blank">
                      <img :src="dealImg(item.analyst_face)" />
                    </a>
                    <p class="name">{{ item.analyst_name }}</p>
                    <p>
                      <span>{{ item.level }}</span>
                    </p>
                  </td>
                  <td>
                    <p :comment="item.seleltname" class="champion">
                      <span v-if="item.seleltname == item.home_name_zh" class="home">
                        {{ item.home_name_zh }}
                        <img src="//static.fly2a.com/static/image/left-champion.png" v-if="item.price == 0" />
                      </span>
                      <span v-else class="home">{{ item.home_name_zh }}</span>

                      <span>
                        VS
                        <span class="time">
                          {{ item.league_name_zh }}&nbsp;{{
            item.matches_time
          }}
                        </span>
                      </span>

                      <span v-if="item.seleltname == item.away_name_zh" class="away">
                        {{ item.away_name_zh }}
                        <img src="//static.fly2a.com/static/image/right-champion.png" v-if="item.price == 0" />
                      </span>
                      <span v-else class="away">{{ item.away_name_zh }}</span>

                      <!-- <span
                        v-if="
                          item.seleltname == '大球' ||
                          (item.seleltname == '小球' && item.price == 0)
                        "
                        class="bigSmall"
                      >
                        <img
                          src="//static.fly2a.com/static/image/ball_icon.png"
                        />
                        <span>{{ item.seleltname }}</span>
                      </span>-->
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="comments">
                      <span v-if="item.price == 0">{{ item.content }}</span>
                      <!--<img v-else src="//static.fly2a.com/static/image/lock.png" width="30px">-->
                      <a class="lock" href="/app" target="_blank" v-else>
                        <div>
                          <img src="//static.fly2a.com/static/image/lock.png" width="30px" />
                        </div>
                        <div class="hint">
                          <span>看推文分析请点击下载</span>
                          <span style="color: red">APP</span>
                        </div>
                      </a>
                    </p>
                    <p>
                      <a :href="'/tuijian/football-analyst?member_id=' +
            item.analyst_id +
            '&recommend_id=' +
            item.recommend_id +
            '&newsIndex=' +
            newsIndex
            " target="_blank">
                        查看更多
                        <img src="//static.fly2a.com/static/image/more2.png" />
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p class="content1_bottom">
          <router-link to="/tuijian" target="_blank">查看更多&nbsp;>></router-link>
        </p>
      </div>
      <div class="index_content2">
        <div class="host_everyday">
          <div>大神榜</div>
        </div>
        <div class="need_shadow">
          <div class="everday_content">
            <ul>
              <li v-for="(item, index) in columnist" :key="index">
                <div>
                  <a :href="item.url" target="_blank">
                    <img :src="dealImg(item.face)" />
                  </a>
                </div>
                <div>
                  <a>
                    <p>{{ item.name }}</p>
                    <p>{{ item.tab }}</p>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <p class="more">
            <router-link to="/tuijian/dashenbang" target="_blank">
              查看更多
              <img src="//static.fly2a.com/static/image/more2.png" />
            </router-link>
          </p>
        </div>
      </div>
    </div>
    <div class="index_footer">
      <div class="footer_content">
        <div class="footer_content1">
          <div>
            <p>
              <span>站点导航</span>
              <a href="//www.qiu006.com" target="_blank">逛球街</a>
              <a href="//www.qiu006.com/zuqiu/" target="_blank">逛球街足球比分</a>
              <a href="//www.qiu006.com/lanqiu/" target="_blank">逛球街篮球比分</a>
              <a href="javascript:void(0)">乐球吧</a>
              <a href="javascript:void(0)">筋头云直播</a>
              <a href="javascript:void(0)">飞速直播</a>
              <a href="javascript:void(0)">乐虎直播</a>
              <a href="javascript:void(0)">球彩直播</a>
              <a href="javascript:void(0)">雷速</a>
              <a href="javascript:void(0)">k球</a>
              <a href="javascript:void(0)">大神推单</a>
              <a href="javascript:void(0)">大神推荐</a>
              <a href="javascript:void(0)">一比分</a>
              <a href="javascript:void(0)">捷报体育</a>
              <a href="javascript:void(0)">爱看球</a>
              <a href="javascript:void(0)">免费高清直播</a>
              <a href="javascript:void(0)">高清视频源</a>
              <a href="javascript:void(0)">比赛结果查询</a>
              <a href="javascript:void(0)">即嗨比分</a>
              <a href="javascript:void(0)">比分app</a>
              <a href="javascript:void(0)">企鹅直播</a>
              <a href="javascript:void(0)">章鱼直播</a>
              <a href="javascript:void(0)">球探</a>
              <a href="javascript:void(0)">比分直播</a>
              <a href="javascript:void(0)">足球直播</a>
              <a href="javascript:void(0)">篮球直播</a>
              <a href="javascript:void(0)">体育直播</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
var stateName = {
  0: "未开赛",
  1: "第一节",
  2: "第二节",
  3: "第三节",
  4: "第四节",
  5: "加时",
  6: "加时",
  7: "加时",
  "-1": "完场",
  "-2": "待定",
  "-3": "中断",
  "-4": "取消",
  "-5": "推迟",
  50: "中场",
};
var stateNameNcaa = {
  0: "未开赛",
  1: "上半场",
  3: "下半场",
  5: "加时",
  6: "加时",
  7: "加时",
  "-1": "完场",
  "-2": "待定",
  "-3": "中断",
  "-4": "取消",
  "-5": "推迟",
  50: "中场",
};
export default {
  name: "index",
  data() {
    return {
      title: [],
      headCon: headCon(),
      hotmatches: [],
      newslist: [],
      rank: [],
      columnist: [],
      f_comment: [],
      b_comment: [],
      hotIndex: 2,
      hotType: 2,
      hottimer: 0,
      newsLi: ["篮球", "中超", "英超", "西甲", "德甲", "意甲"],
      newsIndex: 0,
      jifenIndex: 0,
      nabIndex: 0,
      tuijianIndex: 0,
      rank1: String,
      rank2: String,
      stateName: stateName,
      stateNameNcaa: stateNameNcaa,
      params: {},
    };
  },
  filters: {
    formateHtml: function (html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const msg = html.replace(re1, ''); // 执行替换成空字符
      return msg;
    }
  },
  metaInfo() {
    return {
      title: this.headCon["title"],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.headCon["description"],
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.headCon["keywords"],
        },
      ],
    };
  },
  created: function () {
    this.request("banner", this.getTitle);
    this.request("getfootball_top?type=2", this.getHotmatches); //热门赛事
    this.request("consult_list/index", this.getNewslist);
    this.request("rank", this.getRank);
    this.request("columnist", this.getColumnist);
    this.request("luckball_day?type=0", this.getFComment); //足球今日精推
    this.request("luckball_day?type=1", this.getBComment); //篮球今日精推
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
  },
  mounted() {
    $(".haed_shouye").addClass("nuxt-link-exact-active");
    this.params = this.$route.query;
    var that = this;
    setTimeout(function () {
      that.swippertab();
    }, 1000);
    var state = 0;
    for (var i = 0; i < this.hotmatches.length; i++) {
      if (this.hotIndex == 1) {
        if (this.hotmatches[i].state >= 1 && this.hotmatches[i].state <= 7) {
          state = 1;
          break;
        }
      } else {
        if (this.hotmatches[i].state >= 2 && this.hotmatches[i].state <= 9) {
          state = 1;
          break;
        }
      }
    }
    if (state) {
      if (!that.hottimer) {
        that.hottimer = setInterval(function () {
          that.hot_click(that.hotIndex);
        }, 30000);
      }
    } else {
      if (that.hottimer) {
        clearInterval(that.hottimer);
        that.hottimer = 0;
      }
    }
    axios.post(COMMOND.NEW_BASE_URL + "add_sta", "type=1&page=index&device=pc");

    window.addEventListener("beforeunload", function (event) {
      axios.post(
        COMMOND.NEW_BASE_URL + "add_sta",
        "type=2&page=index&device=pc"
      );
    });

    var storageKey = '__SCORE_PC__'
    var t = localStorage.getItem(storageKey) || ''
    var today = dayjs().format('YYYYMMDD')
    if (t !== today) {
      $('.modal-score').fadeIn()
      localStorage.setItem(storageKey, today)
    }
  },
  methods: {
    request(url, fn) {
      url = COMMOND.NEW_BASE_URL + url;
      axios.get(url).then((res) => {
        if (fn) {
          fn(res.data);
        }
      });
    },
    getTitle(data) {
      this.title = data.data;
    },
    getHotmatches(data) {
      this.hotmatches = [];
      this.hotIndex = this.hotType;
      if (data.data) {
        this.hotmatches = data.data;
        var state = 0;
        for (var i = 0; i < this.hotmatches.length; i++) {
          if (this.hotIndex == 1) {
            if (
              this.hotmatches[i].state >= 1 &&
              this.hotmatches[i].state <= 5
            ) {
              state = 1;
              break;
            }
          } else {
            if (
              this.hotmatches[i].state >= 1 &&
              this.hotmatches[i].state <= 7
            ) {
              state = 1;
              break;
            }
          }
        }
        var that = this;
        if (state) {
          if (!that.hottimer) {
            that.hottimer = setInterval(function () {
              that.hot_click(that.hotIndex);
            }, 30000);
          }
        } else {
          if (that.hottimer) {
            clearInterval(that.hottimer);
            that.hottimer = 0;
          }
        }
      } else {
        this.hotmatches = [];
      }
      $("footer").show();
    },
    getNewslist(data) {
      this.newslist = data.data;
      //				this.gaiUl();
    },
    getRank(data) {
      this.rank = data.data;
      //				this.rankFunction()
    },
    getColumnist(data) {
      this.columnist = data.data;
    },
    getFComment(data) {
      if (data.data) {
        this.f_comment = data.data;
      }
    },
    getBComment(data) {
      if (data.data) {
        this.b_comment = data.data;
      }
    },
    dealImg(src) {
      if (src) {
        //					if(src.indexOf("//") != -1) {
        return src;
        //					} else {
        //						if(src[0] == "/") {
        //							return "https://api.qiu006.com" + src
        //						} else {
        //							return "https://api.qiu006.com/" + src
        //						}
        //					}
      } else {
        return "";
      }
    },
    swippertab() {
      //轮播图初始化
      var swiper = new Swiper(".swiper-container", {
        spaceBetween: 30,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        //					autoplay: 3000,
        pagination: ".swiper-pagination",
        paginationClickable: true,
      });
      var prev = document.querySelector(
        ".swiper-container .swiper-button-prev"
      );
      var next = document.querySelector(
        ".swiper-container .swiper-button-next"
      );
      var container = document.querySelector(".swiper-container");
      prev.addEventListener("click", function (e) {
        swiper.swipePrev();
      });
      next.addEventListener("click", function (e) {
        swiper.swipeNext();
      });
      container.addEventListener("mouseenter", function () {
        swiper.stopAutoplay();
      });
      container.addEventListener("mouseleave", function () {
        swiper.startAutoplay();
      });
    },
    //热门赛事
    hot_click(index) {
      this.request("getfootball_top?type=" + index, this.getHotmatches);
      this.hotType = index;
    },
    toAnalyst(analystId, recommendId) {
      window.open(
        window.location.protocol +
        "//" +
        window.location.host +
        "/tuijian/football-analyst?member_id=" +
        analystId +
        "&recommend_id=" +
        recommendId +
        "&newsIndex=0"
      );
    },
    toLive(id, tv) {
      var zhibo = 0;
      if (tv) {
        zhibo = 1;
      }
      if (this.hotIndex == 1) {
        return COMMOND.DOMAIN_NAME + "/zuqiu/live?id=" + id + "&zhibo=" + zhibo;
      } else {
        return (
          COMMOND.DOMAIN_NAME + "/lanqiu/live?id=" + id + "&zhibo=" + zhibo
        );
      }
    },
    getCookie(name) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return "";
    },
    ontimeFn(timer) {
      var t = parseInt(timer / 60);
      var h = t >= 10 ? t : "0" + t;
      var s = timer % 60 >= 10 ? timer % 60 : "0" + (timer % 60);
      return h + ":" + s;
    },
    //积分榜----------------------------------------
    rankFunction() {
      //积分榜数据处理
      var list = this.rank;
      var rankStr1 = "";
      for (var i = 0; i < 5; i++) {
        rankStr1 += '<div class="jifen_view" ref="' + i + '">';
        rankStr1 += '<ul class="view1">';
        var curr = list[i];
        for (var j = 0; j < curr.length; j++) {
          rankStr1 += "<li><div>" + curr[j].ranking + "</div>";
          //						if(curr[j].logo.indexOf("http:") != -1 || curr[j].logo.indexOf("https:") != -1) {
          rankStr1 +=
            '<div><img src="' + curr[j].logo + '">' + curr[j].team + "</div>";
          //						} else {
          //							rankStr1 +=
          //								'<div><img src="https://api.qiu006.com' +
          //								curr[j].logo +
          //								'">' +
          //								curr[j].team +
          //								"</div>";
          //						}
          rankStr1 += "<div>" + curr[j].mark + "</div>";
          rankStr1 += "<div>" + curr[j].points + "</div>";
          rankStr1 += "</li>";
        }
        rankStr1 += "</ul>";
        rankStr1 += "</div>,,";
      }
      var rankStr2 = "";
      for (var i = 5; i < 8; i++) {
        rankStr2 += '<div class="jifen_view" ref="' + i + '">';
        var curr = list[i];
        rankStr2 += '<ul class="view1">';
        for (var j = 0; j < curr.length; j++) {
          rankStr2 += "<li><div>" + curr[j].ranking + "</div>";
          if (curr[j].logo) {
            //							if(curr[j].logo.indexOf("http:") != -1 || curr[j].logo.indexOf("https:") != -1) {
            rankStr2 +=
              '<div><img src="' + curr[j].logo + '">' + curr[j].team + "</div>";
            //							} else {
            //								rankStr2 +=
            //									'<div><img src="https://api.qiu006.com' +
            //									curr[j].logo +
            //									'">' +
            //									curr[j].team +
            //									"</div>";
            //							}
          } else {
            rankStr2 += "<div>" + curr[j].team + "</div>";
          }
          rankStr2 += "<div>" + curr[j].mark + "</div>";
          rankStr2 += "<div>" + curr[j].points + "</div>";
          rankStr2 += "</li>";
        }
        rankStr2 += "</ul>";
        rankStr2 += "</div>,,";
      }
      this.rank1 = rankStr1
        .split(",,")
        .slice(0, rankStr1.split(",,").length - 1);
      this.rank2 = rankStr2
        .split(",,")
        .slice(0, rankStr2.split(",,").length - 1);
    },
    jifen_click(index) {
      //tab切换
      this.jifenIndex = index;
      if (index == 6) {
      }
      //				if(index == 7) {
      //					var nw = this.$refs.nwTab;
      //					nw.children[0].style.display = "none";
      //					nw.children[1].style.display = "none";
      //				}
    },
    nab_click(index) {
      //东西部切换
      this.nabIndex = index;
      var nw = this.$refs.nwTab; //东西部
      if (index === 0) {
        nw.children[0].style.display = "block";
        nw.children[1].style.display = "none";
      } else {
        nw.children[0].style.display = "none";
        nw.children[1].style.display = "block";
      }
    },
    //			//即时资讯--------------------------------------
    //			gaiUl() {
    //				//即时资讯返回数据切割一条条
    //				var cha = this.newslist.split("</ul>");
    //				var cha1 = "";
    //				for(var i = 0; i < cha.length; i++) {
    //					cha1 += cha[i];
    //				}
    //				var cha2 = cha1.split("<ul>");
    //				this.newsUl = cha2;
    //				var that = this;
    //				setTimeout(function(){
    //					that.handleGaiUl()
    //				},1000)
    //			},
    //			handleGaiUl() {
    //				var div = document.querySelectorAll('.news_content a')
    //				for(var i = 0; i < div.length; i++) {
    //					if(div[i].getAttribute("href").indexOf("/news/detail") == -1) {
    //						div[i].removeAttribute("href")
    //					}
    //				}
    //			},
    news_click(index) {
      //tab切换
      if (index == 6) {
        let routeUrl = this.$router.resolve({
          path: "/tuijian",
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.newsIndex = index;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "../assets/css/index.css";

body,
html {
  background-color: #fff;
}

.vwrapper {
  position: relative;
}

.vwrapper .recommend {
  position: absolute;
  top: 42px;
  right: 26px;
  font-size: 18px;
  line-height: 40px;
  color: #292928;
  padding-left: 50px;
  background: url("//static.fly2a.com/static/image/ball_icon.png") left top no-repeat;
  background-size: auto 32px;
}

.vwrapper .hit {
  position: absolute;
  right: 16px;
  top: 82px;
  width: 64px;
  height: 64px;
}

.vwrapper:nth-child(1) .hit {
  top: 66px;
}

.vwrapper:nth-child(1) .recommend {
  top: 26px;
}

.champion span {
  vertical-align: middle;
}

.redcard {
  margin-top: -3px;
  border-radius: 2px;
  vertical-align: middle;
  display: inline-block;
  font-size: 12px;
  padding: 4px 4px;
  color: #fff;
  background-color: #e24949;
}

.yellowcard {
  margin-top: -3px;
  border-radius: 2px;
  vertical-align: middle;
  display: inline-block;
  font-size: 12px;
  padding: 4px 4px;
  color: #fff;
  background-color: #ff9600;
}
</style>
